import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import { getUsers } from "../redux/admin/action";

const Users = () => {
 const dispatch = useDispatch();
 const { users } = useSelector((store) => store.admin);
 const [rows, setRows] = useState([]);
 const [columns, setColumns] = useState([]);

 useEffect(() => {
  if (users.length <= 0) {
   dispatch(getUsers());
  }
 }, [users, dispatch]);

 // Format users data for DataGrid
 useEffect(() => {
  if (users.length > 0) {
   const formattedRows = users.map((user) => {
    return {
     id: user._id,
     name: user.name,
     mobile: user.mobile,
     verify: user.verify ? "Yes" : "No",
     referral_code: user.referral_code,
     selectedBrand: user.selectedBrand ? user.selectedBrand.name : "N/A",
     selectedCar: user.currentCar ? user.currentCar.title : "N/A",
     cars: user.cars.map((car) => car.title).join(", "), // Display car titles as comma separated
     address:
      user.addresses.length > 0 ? user.addresses[0].completeAddress : "N/A", // Showing only the first address for simplicity
    };
   });

   setRows(formattedRows);
  }
 }, [users]);

 // Columns configuration for DataGrid
 useEffect(() => {
  setColumns([
   { field: "name", headerName: "Name", width: 180 },
   { field: "mobile", headerName: "Mobile", width: 180 },
   { field: "verify", headerName: "Verified", width: 120 },
   //    { field: "referral_code", headerName: "Referral Code", width: 160 },
   //    { field: "selectedBrand", headerName: "Selected Brand", width: 200 },
   { field: "selectedCar", headerName: "Selected Car", width: 180 },
   { field: "cars", headerName: "Cars", width: 300 },
   { field: "address", headerName: "Address", width: 350 },
  ]);
 }, []);

 return (
  <Box sx={{ width: "100%", height: "70vh", padding: "20px" }}>
   <Typography fontSize={"25px"} paddingLeft="5px" fontWeight={"600"}>
    Users
   </Typography>
   <div style={{ height: 600, width: "100%" }}>
    <DataGrid
     rows={rows}
     columns={columns}
     pageSize={5}
     rowsPerPageOptions={[5, 10, 15]}
     disableSelectionOnClick
    />
   </div>
  </Box>
 );
};

export default Users;
